import { CurrentAgreementVersions, LegalAgreement } from "../types/legal.types";

const isAgreementCompliant = (
  employeeAgreement: LegalAgreement | null,
  currentVersions: CurrentAgreementVersions | null
): boolean => {
  if (!employeeAgreement || !currentVersions) return false;

  return (
    employeeAgreement.cookies_policy_accepted &&
    employeeAgreement.terms_accepted &&
    employeeAgreement.privacy_policy_accepted &&
    employeeAgreement.cookies_policy_version ===
      currentVersions.cookies_policy_version &&
    employeeAgreement.terms_version === currentVersions.terms_version &&
    employeeAgreement.privacy_policy_version ===
      currentVersions.privacy_policy_version
  );
};

export default isAgreementCompliant;
